<p-menubar *ngIf="!hidden && internalType() != 'Side'" [model]="menus()" [autoDisplay]="false" [class]="hostClasses"
  (dblclick)="switchNavigationType($event)">
  <ng-template pTemplate="end">
    <div *ngIf="enableSearch && isLoggedIn()" class="menu-search-icon" (click)="openSearchModal()"
      title="Open search modal (Ctrl+Shift+P)">
      <i class="pi pi-search"></i>
    </div>
  </ng-template>

</p-menubar>

<div *ngIf="!hidden && internalType() == 'Side'" class="sidebar-container flex flex-column p-justify-between"
  (dblclick)="switchNavigationType($event)" [ngClass]="{'collapsed-menu': collapsedMenu() && !searchActive()}">

  <zappIcon *ngIf="!notCollapsible" themeIcon="bars" [circularBackground]="false" (click)="toggleMenu()" class="toggle">
  </zappIcon>

  <p-tieredMenu [model]="menusVertical()[0]" [autoDisplay]="false" [class]="hostClasses" [appendTo]="'body'"
    [styleClass]="'vertical'"></p-tieredMenu>
  <div>
    <p-tieredMenu [model]="menusVertical()[1]" [class]="hostClasses" [styleClass]="'vertical bottom-menu'"
      [ngClass]="{'collapsed-menu': collapsedMenu() && !searchActive()}">
    </p-tieredMenu>
    <div *ngIf="enableSearch && isLoggedIn()" class="search-icon-container">
      <div class="menu-search-icon" (click)="openSearchModal()" title="Open search modal (Ctrl+Shift+P)">
        <i class="pi pi-search"></i>
      </div>
    </div>
  </div>
</div>

<zapp-searchmodal #SearchModal [indexes]="showIndexes" [showMenuSearch]="enableSearch" [showFavorites]="enableFavorites"
  [showMostUsed]="enableMostUsed" [menuItems]="items" [menuName]="name">
</zapp-searchmodal>